<template>
    <section class="section section--example">
        <div class="container">
            <div class="container-950">
                <div class="row">
                    <div class="col-12 text-left text-sm-center">
                        <slot name="modal-header"></slot>                         
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <div @click="showModal()">
                            <slot name="modal-img-trigger"></slot>
                        </div>                                                    
                    </div>
                    <div class="col-12 col-sm-6">
                        <slot name="modal-content"></slot>
                    </div>
                </div>
            </div>
        </div>
        <!-- start modal -->
        <div :class="{show, 'd-block': active}" class="modal fade " id="modal" tabindex="-1" role="dialog" aria-labelledby="modalTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="toggleModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    <div class="modal-body text-center color-black">
                        <slot name="modal-img-popup"></slot>
                    </div>
                </div>
            </div>
        </div>
        <!-- end modal -->
    </section>
</template>

<script>

    export default {
        name: "SectionExemple",
        data(){
            return {
                show: false,
                active: false,
            }
        },

        methods: {
            toggleModal() {
                const body = document.querySelector("body");
                this.active = !this.active;
                this.active
                    ? body.classList.add("modal-open")
                    : body.classList.remove("modal-open");
                setTimeout(() => (this.show = !this.show), 10);
            },
            showModal() {
                this.show = !this.show;
                this.active = !this.active;
            }
        }
    };
</script>